import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import DateTimeInput from "../../../Components/Forms/datetime";
import DateInput from "../../../Components/Forms/date";
import TimeInput from "../../../Components/Forms/time";
import {
  renderField,
  renderTextField,
  renderselect,
} from "../../../Components/Forms/renders";
class LogboekFormWebsite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      inschrijving: false,
    };
  }

  inschrijving = (value) => {    
      this.setState({inschrijving: JSON.parse(value.target.value)})
  }
  render() {
    const { handleSubmit } = this.props;    
    return (
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <Field
            name="datum"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={DateInput}
            label="Datum van de Activiteit"
          />
          <Field
            name="tijd"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={TimeInput}
            label="Tijd van de activiteit"
          />
          <Field
            name="activiteit"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Naam van de activiteit"
          />
          <Field
            name="beschrijving"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderTextField}
            label="Naam van de activiteit"
          />
          <Field
            name="inschrijving"
            validate={required({ msg: "Type item is verplicht" })}
            label="Inschrijving noodzakelijk"
            component={renderselect}
            options={{
              true: "Ja",
              false: "Nee",
            }}
            onChange={(value) => this.inschrijving(value)}
          />
          {this.state.inschrijving && (
            <div>
              <Field
                name="maxdeelnemers"
                type="number"
                validate={required({ msg: "Dit item is verplicht" })}
                component={renderField}
                label="Maximaal aantal deelnemers"
              />
              <Field
                name="startinschrijving"
                component={DateTimeInput}
                type="input"
                validate={required({ msg: "Dit item is verplicht" })}
                label="Start datum inschrijvingen"
              />
              <Field
                name="eindinschrijving"
                component={DateTimeInput}
                type="input"
                maxDate={this.props.initialValues.datum}
                validate={required({ msg: "Dit item is verplicht" })}
                label="Eind datum inschrijvingen"
              />
                <Field
                name="betaald"
                type="input"
                validate={required({ msg: "Dit item is verplicht" })}
                label="Is het een betaalde activiteit"
                component={renderselect}
                options={{
                  true: "Ja",
                  false: "Nee",
                }}
              />
            </div>
          )}
          <input
            type="submit"
            className="btn btn-next btn-fill btn-success btn-wd btn-mg"
            name="next"
            value="Aanmaken"
          />
        </div>
      </form>
    );
  }
}
LogboekFormWebsite = reduxForm({
  form: "formprofiel", // a unique identifier for this form
})(LogboekFormWebsite);

// You have to connect() to any reducers that you wish to connect to yourself
LogboekFormWebsite = connect(
  (state) => ({
    initialValues: state.website.item, // pull initial values from account reducer
  }) // bind account loading action creator
)(LogboekFormWebsite);

export default LogboekFormWebsite;
